// extracted by mini-css-extract-plugin
export var content = "SideMenu-module--content--eb678";
export var fadeInAnimation = "SideMenu-module--fadeInAnimation--bef80";
export var wrapper = "SideMenu-module--wrapper--ce520";